import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { FilterOption, MainDataService } from 'app/services/main-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-feat-filter-labels-qacode',
  templateUrl: './feat-filter-labels-qacode.component.html',
  styleUrls: ['./feat-filter-labels-qacode.component.css', '../feat-attribute-filter-labels/feat-attribute-filter-labels.component.css']
})
export class FeatFilterLabelsQacodeComponent implements OnInit, OnDestroy {

	selectedFilterOptions: FilterOption[];
	private options: FilterOption[];

	private qcFilterSub: Subscription;
	private applySub: Subscription;

	constructor(
		private activityService: ActivityService,
		private mainDataService: MainDataService
	) { }

	removeFilter(idx: number) {
		this.selectedFilterOptions.splice(idx, 1);
		const filterOptions = this.mainDataService.qcFilterInfo.getValue().filterOptions;
		filterOptions.forEach(i => i.isSelected = !!this.selectedFilterOptions.find(op => op.value === i.value));
		this.mainDataService.qcFilterInfo.next({
			filterOptions: filterOptions
		});
	}

	ngOnInit() {
		this.qcFilterSub = this.mainDataService.qcFilterInfo.subscribe(data => {
			// Clear labels if filterOptions object has changed (for example, when selecting another layer)
			if (this.options !== data.filterOptions) {
				this.options = data.filterOptions;
				this.selectedFilterOptions = this.options.filter(i => i.isSelected);
			}
			// Update selectedOptions when getData
			if (!data.skipGetData) {
				this.selectedFilterOptions = this.options.filter(i => i.isSelected);
			}
		});
		// Only update selectedOptions when Apply btn is clicked
		this.applySub = this.activityService.applyAttrFilterSubject.subscribe(() => {
			this.selectedFilterOptions = this.mainDataService.qcFilterInfo.getValue().filterOptions.filter(i => i.isSelected);
		})
	}

	ngOnDestroy(): void {
		this.qcFilterSub.unsubscribe();
		this.applySub.unsubscribe();
	}
}
